export default __webpack_public_path__ + "static/media/chevron.8093531e.svg";